import React from "react";
import { Link } from "react-router-dom";

export default function FaqContactBar() {
  return (
    <div className="faq-contact-bar">
      <div>
        <h6>Still have questions?</h6>
        <p>Can't find the answer you're looking for? Please chat to our friendly team.</p>
      </div>
      <Link to="/contact" className="btn-mu-solid flex-shrink-0">Send Message</Link>
    </div>
  );
}
